const locale = {
  startsWith: "Начинается с",
  contains: "Содержит",
  notContains: "Не содержит",
  endsWith: "Заканчивается на",
  equals: "Равно",
  notEquals: "Не равно",
  noFilter: "Без фильтра",
  lt: "Меньше чем",
  lte: "Меньше либо равно чем",
  gt: "Больше чем",
  gte: "Больше либо равно чем",
  dateIs: "Дата равна",
  dateIsNot: "Дата не равна",
  dateBefore: "Дата до",
  dateAfter: "Дата после",
  clear: "Очистить",
  apply: "Применить",
  matchAll: "Совпадение всех",
  matchAny: "Совпадение любому",
  addRule: "Добавить правило",
  removeRule: "Удалить правило",
  accept: "Да",
  reject: "Нет",
  choose: "Выберите",
  upload: "Загрузить",
  cancel: "Отмена",
  dayNames: [
    "Воскресенье",
    "Понедельник",
    "Вторник",
    "Среда",
    "Четверг",
    "Пятница",
    "Субботу",
  ],
  dayNamesShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  dayNamesMin: ["В", "П", "В", "С", "Ч", "П", "С"],
  monthNames: [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ],
  monthNamesShort: [
    "Янв",
    "Фев",
    "Мар",
    "Апр",
    "Май",
    "Июнь",
    "Июль",
    "Авг",
    "Сен",
    "Окт",
    "Ноя",
    "Дек",
  ],
  today: "Сегодня",
  weekHeader: "нед.", // ???, Wk
  firstDayOfWeek: 1,
  dateFormat: "yy.mm.dd",
  weak: "Слабый",
  medium: "Средний",
  strong: "Сильный",
  passwordPrompt: "Введите пароль",
  emptyFilterMessage: "Нет результатов",
  emptyMessage: "Нет доступных вариантов", // опций, No available option
};

export default locale;
